import { apiClient } from './authenticatedApiClient';
import { AppSingletonPromise } from './AppSingletonPromise';
import { ISetting } from '@/model/ISetting';

class AppSettingsService {
  @AppSingletonPromise
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getSettings(force = false): Promise<ISetting[]> {
    return apiClient.get<ISetting[]>('Settings/').then(response => {
      return response.data;
    });
  }

  public patchSetting(setting: ISetting): Promise<void> {
    return apiClient.patch(`Settings/${setting.key}`, { value: setting.value });
  }
}

export const appSettingsService = new AppSettingsService();
